import {FadeAnimation} from './animations/FadeAnimation';
import {SlideAnimation,SlideAnimationPosition} from './animations/SlideAnimation';

declare var BreakRange:any;
declare var callback:any;

export class Sidepane {

    private static sidepanes:Sidepane[]=[];
    private open:boolean=false;
    private postVars:any={};

    constructor(private id:string) {
        let existing=Sidepane.sidepanes.find(x=>x.id==id);
        if (existing) return existing;
        Sidepane.sidepanes.push(this);
    }

    public static closeAll() {
        for (let sidepane of this.sidepanes) {
            if (sidepane.open) sidepane.hide();
        }
    }

    private getContainer() {
        let e=$('.'+this.id.replaceAll('_','-')+'-container');
        return e;
    }

    private getElement() {
        let e=$('.'+this.id.replaceAll('_','-'));
        return e;
    }

    private detectSide() {
        let e=this.getElement();
        if (parseInt(e.css('right'))==0) return 'right';
        return 'left';
    }

    private formToArray(elem:HTMLFormElement) {
        let output:any={};
        new FormData(elem).forEach(
            (value,key)=>{
                var is_array=(key.slice(-2)=='[]');
                if (is_array) {
                    key=key.slice(0,-2);
                    if (!output.hasOwnProperty(key)) output[key]=[];
                    output[key].push(value);
                } else {
                    if (value!=='') output[key]=value;
                }
            }
        );
        return output;
    }

    private post(post:any) {
        this.postVars=post;
        return this;
    }

    private getPostFormElement() {
        let forms:JQuery<HTMLFormElement>=$('form');
        for (let form of forms) {
            let css=$(form).css('--sidepane-attach');
            if (!css) continue;
            let sforms=css.split(' ');
            if (sforms.includes(this.id)) return $(form) as JQuery<HTMLFormElement>;
        }
    }

    private getSubmitOptions() {
        let postFormElement=this.getPostFormElement();
        let formData=postFormElement?this.formToArray(postFormElement[0]):{};
        let opts:any={
            name:this.id,
            post:{...formData,...this.postVars}
        };
        return opts;
    }

    public async refresh() {
        if (!this.open) return;

        let container=this.getContainer();

        container.addClass('loading');

        let opts=this.getSubmitOptions();

        let e=this.getElement();
        if (e.length) {
            opts['container']=e;
            opts['action']='outerHTML';
        }

        await callback(opts);

        container.removeClass('loading');
    }

    private findScrollAnchor(container:JQuery<HTMLElement>) {
        let elements=container.find('*');
        for (let element of elements) {
            let css=$(element).css('--sidepane-scroll-anchor');
            if (!css) continue;
            if (css.trim()=='true') return $(element);
        }
    }

    private getScrollableParent(elem:JQuery<HTMLElement>) {
        let result=elem.parents().filter(function() {
            let overflowY = $(this).css("overflow-y");
            let overflowX = $(this).css("overflow-x");
            let overflow = $(this).css("overflow");
            return /(auto|scroll)/.test(overflow + overflowY + overflowX);
        }).first();
        if (result.length) return result;
        return $('html');
    }

    private scrollIntoView(elem:JQuery<HTMLElement>) {
        let container=this.getScrollableParent(elem);
        let containerOffset=container.offset();
        let containerHeight=container.height();
        let containerScrollTop=container.scrollTop();
        assert(containerOffset!==undefined && containerHeight!==undefined && containerScrollTop!==undefined);

        let elemOffset=elem.offset();
        let elemHeight=elem.height();
        assert(elemOffset!==undefined && elemHeight!==undefined);

        let shift=(containerHeight-elemHeight)/2;
        let y=elemOffset.top+containerScrollTop-containerOffset.top;
        container[0].scrollTo({top:y-shift});
    }

    private async show(btn:JQuery<HTMLElement>|null=null) {
        this.open=true;
        btn?.addClass('loading');

        let container=this.getContainer();

        let opts=this.getSubmitOptions();

        if (!container.length) {
            opts['protector']=(e:JQuery<HTMLElement>)=>new FadeAnimation(e).to(1).play();
        }

        let e=this.getElement();
        if (e.length) {
            opts['container']=e;
            opts['action']='outerHTML';
        }

        if (btn && btn.length) opts['element']=btn;

        await callback(opts);

        let slideElement=this.getElement();
        if (container.length) slideElement=container;

        btn?.removeClass('loading');
        let side=this.detectSide();
        slideElement.css('translate','none');

        let scrollAnchor=this.findScrollAnchor(slideElement);
        if (scrollAnchor) this.scrollIntoView(scrollAnchor);

        await new SlideAnimation(slideElement).from(<SlideAnimationPosition>side,slideElement.width()).to('center').play();
        e=this.getElement();
        e.on('click',(evt)=>this.onClick(evt));
        // There's also :focusable from JQuery UI but we can't assume JQuery UI is always available
        // so we list all focusable elements individually here.
        e.find('a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]')
        .not('[tabindex=-1], [disabled], :hidden, .close').first().focus();
    }

    private onClick(evt:JQuery.TriggeredEvent) {
        let e=$(evt.target);
        if (e.is('a[href]:not([target="_blank"])')) {
            this.hide();
        }
        let closeBehavior=e.css('--sidepane-autoclose')?.replaceAll(/^["|']|["|']$/g,'');
        if (closeBehavior && new BreakRange(closeBehavior).matches()) {
            this.hide();
        }
    }

    public async hide() {
        this.open=false;
        let side=this.detectSide();
        let e=this.getElement();

        let slideElement=e;
        let container=this.getContainer();
        if (container.length) slideElement=container;

        let anims=[];
        anims.push(new SlideAnimation(slideElement).from('center').to(<SlideAnimationPosition>side,slideElement.width()).play());

        let protector=$('.protector');
        if (protector.length) anims.push(new FadeAnimation(protector).to(0).play());

        await Promise.all(anims);

        if (container.length) e.empty(); else e.remove();
        protector.remove();
    }

    public toggle(btn:JQuery<HTMLElement>|null=null) {
        let e=this.getElement();
        if (!this.open) this.show(btn); else this.hide();
    }

}

export {};